module.exports = __webpack_public_path__ + "static/media/printing-services-img3.e1c29290.jpg";